
export default {
    meta: { requiresAuth: true, allowPermission: 'locations:list' },
    path: "/localidades",
    name: "Locations",
    component: () => import("@/presentation/views/Locations/Locations.vue"),
    redirect: { name: "LocationsList" },

    list: {
        path: "lista",
        name: "LocationsList",
        component: () =>
            import(
                "@/presentation/views/Locations/LocationsList/LocationsList.vue"
            ),
    },
    detail: {
        path: "detalhes/:id",
        name: "LocationDetail",
        component: () =>
            import(
                "@/presentation/views/Locations/LocationDetail/LocationDetail.vue"
            ),
        redirect: { name: "LocationDetailChargers" },
        chargers: {
            path: "carregadores",
            name: "LocationDetailChargers",
            component: () =>
                import(
                    "@/presentation/views/Locations/LocationDetail/LocationDetailChargers/LocationDetailChargers.vue"
                ),
        },
        hours: {
            path: "horarios",
            name: "LocationDetailHours",
            component: () =>
                import(
                    "@/presentation/views/Locations/LocationDetail/LocationDetailHours/LocationDetailHours.vue"
                ),
        },
        partnership_info: {
            path: "parceria",
            name: "LocationPartnershipDetail",
            component: () =>
                import(
                    "@/presentation/views/Partnerships/PartnershipInfoTab/PartnershipInfoTab.vue"
                ),
        },
    },
    add: {
        path: "adicionar",
        name: "AddLocation",
        component: () =>
            import("@/presentation/views/Locations/AddLocation/AddLocation.vue"),
    },
    edit: {
        path: "editar/:id",
        name: "EditLocation",
        component: () =>
            import("@/presentation/views/Locations/EditLocation/EditLocation.vue"),
    },
} as const